import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/service/rest.service';

@Component({
  selector: 'app-app-nav',
  templateUrl: './app-nav.component.html',
  styleUrls: ['./app-nav.component.css']
})
export class AppNavComponent implements OnInit {
  IS_REGISTRATION_OPEN = false

  constructor(private restApi: RestService) { }

  ngOnInit(): void {
    this.getBranch()
  }

  getBranch() {
    this.restApi.getbranch().subscribe((res: any) => {
      this.IS_REGISTRATION_OPEN = res.IS_REGISTRATION_OPEN
    })
  }

}
